import React, { useState, useEffect } from 'react'
import SideBar from '../../SideBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'


const Quotes = () => {
  const [policyData, setPolicyData] = useState({})
  const navigate = useNavigate()

  useEffect(() => {
    setPolicyData(JSON.parse(localStorage.getItem('policyData')))
    const org = JSON.parse(localStorage.getItem('orgType'))

    if (!policyData?.policy_id) return
  }, [policyData?.policy_id])

  return (
    <div className="w-full">
      <div className="flex flex-col lg:flex-row max-w-[90rem] mx-auto lg:space-x-6 mt-24">
        <main className="w-full text-sas-dark">
          <div className='grid grid-cols-3 gap-4'>
            <div className='bg-white rounded-lg shadow-md m-4'>
              <div className='text-center space-y-4  px-4 pt-4 pb-6 border-b mx-8 mt-2'>
                <div><span className='bg-yellow-200 rounded-lg px-4 py-2 text-yellow-800 text-sm'>Lowest Price</span></div>
                <div className='text-xl pt-3'>AIS</div>
                <div>
                  <div className='text-4xl'>£120,000*</div>
                  <div className='text-xs'>Premium per year</div>
                </div>
              </div>
              <div className='p-4 w-64 mx-auto mb-2'>
                <div className='mt-2 font-semibold text-lg mb-2'>Whats included</div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Sickness or injury absences</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Accidents in or out of work</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Phased returns to work</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Compassionate leave</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Bereavement</span></div>
              </div>
              <div className='text-center py-8 border-t mx-8'>
                {/* <p>To discuss this quote, please contact us on <span>01773814400</span></p> */}
                <button onClick={() => navigate('/sai/quote-details/basic')} className='bg-sas rounded-lg px-4 py-2 text-white text-lg shadow-lg  transition delay-150 duration-300 ease-in-out hover:scale-110 hover:bg-indigo-500 cursor-pointer'>Choose this Quote <FontAwesomeIcon icon={faArrowRight} /></button>
              </div>
            </div>
            <div className='bg-white rounded-lg shadow-md'>
              <div className='text-center space-y-4 px-4 pt-4 pb-6 border-b mx-8 mt-2'>
                <div><span className='bg-green-200 rounded-lg px-4 py-2 text-green-800'>Enhanced Price</span></div>
                <div className='text-xl pt-3'>AIS</div>
                <div>
                  <div className='text-4xl'>£140,000*</div>
                  <div className='text-xs'>Premium per year</div>
                </div>
              </div>
              <div className='p-4 w-64 mx-auto mb-2'>
                <div className='mt-2 font-semibold text-lg mb-2'>Whats included</div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Sickness or injury absences</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Accidents in or out of work</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Phased returns to work</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Compassionate leave</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Bereavement</span></div>
              </div>
              <div className='text-center pb-6 pt-12 border-t mx-8'>
                 {/* <p>To discuss this quote, please contact us on <span>01773814400</span></p> */}
                <button onClick={() => navigate('/sai/quote-details/enhanced')} className='bg-sas rounded-lg px-4 py-2 text-white text-lg shadow-lg transition delay-150 duration-300 ease-in-out hover:scale-110 hover:bg-indigo-500 cursor-pointer'>Choose this Quote <FontAwesomeIcon icon={faArrowRight} /></button>
              </div>
            </div>
            <div className='bg-white rounded-lg shadow-md m-4'>
              <div className='text-center space-y-4  px-4 pt-4 pb-6 border-b mx-8 mt-2'>
                <div><span className='bg-violet-200 rounded-lg px-4 py-2 text-violet-800 text-sm'>Higher Price</span></div>
                <div className='text-xl pt-3'>AIS</div>
                <div>
                  <div className='text-4xl'>£160,000*</div>
                  <div className='text-xs'>Premium per year</div>
                </div>
              </div>
              <div className='p-4 w-64 mx-auto mb-2'>
                <div className='mt-2 font-semibold text-lg mb-2'>Whats included</div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Sickness or injury absences</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Accidents in or out of work</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Phased returns to work</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Compassionate leave</span></div>
                <div className='space-x-2'><FontAwesomeIcon icon={faCircleCheck} className='text-green-600' /><span>Bereavement</span></div>
              </div>
              <div className='text-center py-8 border-t mx-8'>
                 {/* <p>To discuss this quote, please contact us on <span>01773814400</span></p> */}
                <button className='bg-sas rounded-lg px-4 py-2 text-white text-lg shadow-lg  transition delay-150 duration-300 ease-in-out hover:scale-110 hover:bg-indigo-500 cursor-pointer'>Choose this Quote <FontAwesomeIcon icon={faArrowRight} /></button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Quotes